// UIStateContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const UIStateContext = createContext();

export function UIStateProvider({ children }) {
    const [state, setState] = useState(() => {
        const saved = localStorage.getItem("admin-ui-state");
        return saved ? JSON.parse(saved) : {};
    });

    useEffect(() => {
        localStorage.setItem("admin-ui-state", JSON.stringify(state));
    }, [state]);

    const setViewState = (key, value) => {
        setState(prev => ({
            ...prev,
            [key]: value
        }));
    };

    const getViewState = (key, fallback = null) => {
        return state[key] ?? fallback;
    };

    return (
        <UIStateContext.Provider
            value={{
                state,
                setViewState,
                getViewState
            }}
        >
            {children}
        </UIStateContext.Provider>
    );
}

export function useUIState() {
    return useContext(UIStateContext);
}